<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('customerService.refund_transaction_details')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card" @open="getDetailInfo">
      <div>
        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('customerService.refund_transaction_amount') }}:</div>
            <div class="total-num color-main-linear-blue">{{ $store.getters.currency }} {{ merchantInfo.refund_transaction_amount | toDivideWithDot }}</div>
          </div>
          <div class="total-item">
            <div class="total-title">{{ $t('customerService.refunded_transaction_fee') }}:</div>
            <div class="total-num color-main-linear-blue">{{ $store.getters.currency }} {{ Math.abs(merchantInfo.refund_transaction_fee) | toDivideWithDot }}</div>
          </div>
          <div class="total-item">
            <div class="total-title">{{ $t('customerService.refund_fee') }}:</div>
            <div class="total-num color-main-linear-blue">{{ $store.getters.currency }} {{ Math.abs(merchantInfo.refund_fee) | toDivideWithDot }}</div>
          </div>
        </div>

        <div class="section-title mb-12 mt-12">
          {{ $t('data.timeline') }}
        </div>

        <div class="line-bottom-1px" />
        <div class="item">
          <span class="item-left content-blue">{{ $t('components.create_time') }}</span>
          <span class="content-gray">{{ merchantInfo.transaction_create_time }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('merchantAccount.complete_time') }}</span>
          <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
        </div>

        <div class="section-title mb-12 mt-36">
          {{ $t('data.description') }}
        </div>
        <div class="line-bottom-1px" />

        <!-- 退款交易编号 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_transaction_id') }}</span>
          <span class="content-gray">{{ merchantInfo.refund_transaction_id }}</span>
        </div>
        <!-- 商户退款订单号 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.mch_refund_order_id') }}</span>
          <span class="content-gray">{{ merchantInfo.mch_order_id }}</span>
        </div>
        <!-- 退款类型 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_type') }}</span>
          <span class="content-gray">{{ getRefundStatusMapLabel(merchantInfo.refund_category) }}</span>
        </div>
        <!-- 退款订单金额 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_order_amount') }}</span>
          <span class="content-gray">{{ merchantInfo.this_time_refund_amount | toDivideWithDot }}</span>
        </div>
        <!-- 退回手续费金额 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refunded_transaction_fee') }}</span>
          <span class="content-gray">{{ merchantInfo.refund_transaction_fee | toDivideWithDot }}</span>
        </div>
        <!-- 退款交易金额 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_transaction_amount') }}</span>
          <span class="content-gray">{{ merchantInfo.refund_transaction_amount | toDivideWithDot }}</span>
        </div>
        <!-- 退款手续费 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_fee') }}</span>
          <span class="content-gray">{{ merchantInfo.refund_fee | toDivideWithDot }}</span>
        </div>
        <!-- 到账金额 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.amount_to_receive') }}</span>
          <span class="content-gray">{{ merchantInfo.actual_receive_refund_amount | toDivideWithDot }}</span>
        </div>
        <!-- 退款手续费承担模式 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_fee_charge_mode') }}</span>
          <span class="content-gray">{{ getTransactionFeeMode(merchantInfo.refund_fee_split_type) }}</span>
        </div>
        <!-- 退款原因 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_reason') }}</span>
          <span class="content-gray">{{ merchantInfo.refund_reason }}</span>
        </div>
        <!-- 原交易编号 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.original_transaction_id') }}</span>
          <span class="content-gray">{{ merchantInfo.original_transaction_id }}</span>
        </div>
        <!-- 原交易金额 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.original_transaction_amount') }}</span>
          <span class="content-gray">{{ merchantInfo.original_transaction_amount | toDivideWithDot }}</span>
        </div>
        <!-- 累计已退订单金额 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.cumulative_amount_refunded') }}</span>
          <span class="content-gray">{{ merchantInfo.refunded_amount | toDivideWithDot }}</span>
        </div>
        <!-- 原交易手续费承担模式 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.original_transaction_fee_charge_mode') }}</span>
          <span class="content-gray">{{ getTransactionFeeMode(merchantInfo.fee_split_type) }}</span>
        </div>
        <!-- 支付方式 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.payment_method') }}</span>
          <span class="content-gray">{{ getPayinPaymentMethodMap(merchantInfo.payment_method) }}</span>
        </div>
        <!-- 支付渠道 -->
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.payment_channel') }}</span>
          <span class="content-gray">{{ merchantInfo.channel_code }}</span>
        </div>

        <el-tag :type="getRefundTypeMapType(merchantInfo.status)" class="payin-status tag-custom"> {{ getRefundTypeMap(merchantInfo.status) }}</el-tag>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { refundDetail } from '@/api/customer-service/customer-service'
import { payinPaymentMethodMap } from '@/maps/transaction'
import {
  refundStatusMap, refundDetailTypeMap, transactionFeeMode
} from '@/utils/maps'
export default {
  name: 'Payment_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: [Number, String],
      default: '0'
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, payment_fee: {}}, // 用户基本信息
      data: {},
      cancel: false
    }
  },
  computed: {
    getRefundTypeMap() {
      return function(value) {
        return refundDetailTypeMap(value).label
      }
    },
    getRefundStatusMapLabel() {
      return function(value) {
        return refundStatusMap(value).label
      }
    },
    getRefundTypeMapType() {
      return function(value) {
        return refundDetailTypeMap(value).type
      }
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    },
    getTransactionFeeMode() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      const params = { refund_transaction_id: this.data.refund_transaction_id }
      refundDetail(params).then(res => {
        if (res.code === 10000) {
          this.merchantInfo = res.data
        }
      })
    },
    // 改变弹框状态
    changModalStatus(value, data = {}) {
      this.dialogTableVisible = value
      this.data = data
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>

<style scoped lang="scss">
.total{
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .total-item{
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(54, 66, 80, 0.20);
    margin-right: 24px;
    &:last-of-type{
      margin-right: 0;
    }
  }
  &-title{
    color: #364250;
    font-size: 12px;
    font-weight: 600;
    word-break: break-word;
  }
  &-num{
    margin-top: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 270px;
  }
}

.content-blue{
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #364250;
}
.content-gray{
  flex: 1;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #488CE8;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 12px;
    left: 250px;
  }
}

</style>
